<template>
  <div v-if="currentUser && isLoggedIn" class="sidebar">
    <div class="cabinet-user">
      <router-link class="cabinet-user__navigation_link" :to="{name: 'profile'}"
                   active-class="cabinet-navigation__link__active"
                   :class="{'cabinet-navigation__link__active':
                   $route.name === 'emailVerification' }">
        <div class="cabinet-user__avatar">
          <img class="cabinet-user__avatar__default" :src="logoUser" alt="default user logo"/>
        </div>
        <div class="cabinet-user__body">
          <p class="cabinet-user__name">{{ currentUser.full_name }}</p>
          <p class="cabinet-user__email">{{ currentUser.is_verified_email ? currentUser.email : currentUser.phone }}</p>
        </div>
      </router-link>
    </div>
    <ul class="cabinet-navigation__list">
      <li class="cabinet-navigation__item">
        <router-link class="cabinet-navigation__link" :to="{name: 'orders'}"
                     active-class="cabinet-navigation__link__active">
          <span class="cabinet-navigation__icon">
            <img class="cabinet-navigation__icon__img" :src="logoCard" alt="card list logo"/>
          </span>
          <span class="cabinet-navigation__label">
            {{ $t('MyOrders') }}
          </span>
        </router-link>
      </li>
      <li class="cabinet-navigation__item">
        <router-link class="cabinet-navigation__link" :to="{name: 'bonus'}"
                     active-class="cabinet-navigation__link__active"
                     :class="{'cabinet-navigation__link__active':
                     $route.name === 'bonusBalance' || $route.name === 'bonusHistory' }">
          <span class="cabinet-navigation__icon">
            <img class="cabinet-navigation__icon__img" :src="logoCash" alt="bonus logo"/>
          </span>
          <span class="cabinet-navigation__label">
            {{ $t('MyBonusAccount') }}
          </span>
        </router-link>
      </li>
      <li class="cabinet-navigation__item">
        <router-link class="cabinet-navigation__link" :to="{name: 'wishlist'}"
                     active-class="cabinet-navigation__link__active">
          <span class="cabinet-navigation__icon">
            <img class="cabinet-navigation__icon__img" :src="logoHeart" alt="List products logo"/>
          </span>
          <span class="cabinet-navigation__label">
            {{ $t('Wishlist') }}
          </span>
        </router-link>
      </li>
      <li class="cabinet-navigation__item">
        <router-link class="cabinet-navigation__link" :to="{name: 'productsViewed'}"
                     active-class="cabinet-navigation__link__active">
          <span class="cabinet-navigation__icon">
            <img class="cabinet-navigation__icon__img" :src="logoEye" alt="See products logo"/>
          </span>
          <span class="cabinet-navigation__label">
            {{ $t('ReviewedProducts') }}
          </span>
        </router-link>
      </li>
      <li class="cabinet-navigation__item">
        <router-link class="cabinet-navigation__link" :to="{name: 'comments'}"
                     active-class="cabinet-navigation__link__active">
          <span class="cabinet-navigation__icon">
            <img class="cabinet-navigation__icon__img" :src="logoComment" alt="comment logo"/>
          </span>
          <span class="cabinet-navigation__label">
            {{ $t('MyReviews') }}
          </span>
        </router-link>
      </li>
    </ul>
  </div>
  <template v-if="!isLoggedIn">
    <dashboard-preloader/>
  </template>
</template>

 <script>
 import {getterTypes, actionTypes, mutationTypes} from "@/store/modules/auth";
 import DashboardPreloader from "@/components/Preloader.vue"
 import {mapGetters} from "vuex";

 export default {
   name: 'DashboardNavbar',
   components: {
     DashboardPreloader
   },
   data() {
     return {
       logoUser: require('@/assets/svg/person-circle.svg'),
       logoCard: require('@/assets/svg/card-list.svg'),
       logoHeart: require('@/assets/svg/suit-heart.svg'),
       logoCash: require('@/assets/svg/cash-coin.svg'),
       logoEye: require('@/assets/svg/eye.svg'),
       logoComment: require('@/assets/svg/chat-left-text.svg'),
       csrf: "",
       authToken: "",
       authGoogleUrl: "",
     }
   },
   computed: {
     ...mapGetters({
       currentUser: getterTypes.currentUser,
       isLoggedIn: getterTypes.isLoggedIn
     })
   },
   methods: {

   },
   mounted(){
     this.csrf = document.getElementById('app').dataset.csrf;
     this.$store.dispatch(actionTypes.setCsrf, this.csrf);

     this.authtoken = document.getElementById('app').dataset.authtoken;
     if (this.authtoken !== null && this.authtoken !== "" && this.authtoken !== undefined) {
       this.$store.dispatch(actionTypes.setAuthToken, `Token ${this.authtoken}`)
     }

     this.authGoogleUrl = document.getElementById('app').dataset.authGoogleUrl;
     this.$store.commit(mutationTypes.setAuthGoogleUrl, this.authGoogleUrl)

     this.$store.dispatch(actionTypes.getCurrentUser)
   }
 }
 </script>

<style lang="scss" scoped>
  @import "@/scss/variables.scss";
  p{
    margin-bottom: 0;
  }
  a{
    text-decoration: none;
  }
  ol, ul {
    list-style: none;
  }
  .pr-0{
    padding-right: 0;
  }
  .pl-0{
    padding-left: 0;
  }

  .sidebar{
    margin-top: 20px;
    .cabinet-user{
      margin-bottom: 4px;
      padding: 16px 8px 8px;
      border-bottom: 1px solid #e9e9e9;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 4px 8px;
      font-size: 14px;
      color: #221f1f;
      transition: all .2s ease-in-out;
      @media only screen and (max-width: $max-width-mobile) {
        padding: 0;
      }
      &__navigation_link{
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-radius: 8px;
        padding: 4px 8px;
        font-size: 14px;
        color: #221f1f;
        transition: all .2s ease-in-out;
        @media only screen and (max-width: $max-width-small) {
          padding: 4px 0;
        }
        @media only screen and (max-width: $max-width-tablet) {
          max-width: 48px;
        }
        &:hover{
          background-color: $fs;
        }
      }
      &__body{
        flex: 1;
        min-width: 0;
        @media only screen and (max-width: $max-width-tablet) {
          display: none;
        }
      }
      &__name{
        font-size: 16px;
        color: $fd;
      }
      &__email{
        font-size: 12px;
        color: $fi;
      }
      &__avatar{
        margin-right: 16px;
        &__default{
          opacity: 80%;
          width: 32px;
          height: 32px;
        }
      }
    }
    .cabinet-navigation{
      &__list{
        padding: 0;
        margin-bottom: 8px;
        padding-bottom: 8px;
        border-bottom: 1px solid #e9e9e9;
      }
      &__item{
        margin-top: 10px;
        margin-bottom: 10px;
        padding-left: 8px;
        padding-right: 8px;
        @media only screen and (max-width: $max-width-mobile) {
          padding: 0;
        }
      }
      &__link{
        display: flex;
        flex-direction: row;
        align-items: center;
        border-radius: 8px;
        padding: 4px 8px;
        font-size: 14px;
        color: #221f1f;
        transition: all .2s ease-in-out;
        @media only screen and (max-width: $max-width-small) {
          padding: 4px 0;
        }
        @media only screen and (max-width: $max-width-tablet) {
          max-width: 56px;
        }
        &__active{
          background-color: $fs;
        }
        &:hover{
          background-color: $fs;
        }
      }
      &__icon{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 40px;
        height: 40px;
        margin-right: 16px;
        border-radius: 50%;
        background-color: #221f1f0d;
        transition: all .2s ease-in-out;
        &__img{
          height: 22px;
          width: 22px;
        }
      }
      &__label{
        @media only screen and (max-width: $max-width-tablet) {
          display: none;
        }
      }
    }
  }
</style>